const swipers = document.querySelectorAll('.slider-recommendations-container');

swipers.forEach((swiper) => {
	const data = swiper.querySelector(`.swiper-data-handler`);
	const sectionId = data.getAttribute('data-section');
	const mySwiper = data.getAttribute('data-class');
	const swipeEffect = data.getAttribute('data-effect');
	const pagination = (data.getAttribute('data-pagination'));
	const buttons = (data.getAttribute('data-buttons'));
	const autoplay = (data.getAttribute('data-autoplay'));
	const colsDesktop = Number(data.getAttribute('data-col-desktop'));
	const colsMobile = Number(data.getAttribute('data-col-mobile'));
	const colsTablet = Number(data.getAttribute('data-col-tablet'));

	let myPagination = document.querySelector(`.swiper-pagination[data-target="${mySwiper}"]`)

	const paginationObj = {
		el: myPagination,
		clickable: true,
	};

	let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="${mySwiper}"]`)
	let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="${mySwiper}"]`)

	const navigationObj = {
		nextEl: mySwiperNext,
		prevEl: mySwiperPrev,
	};

	const autoplayObj = {
		delay: 3000,
		disableOnInteraction: true,
		pauseOnMouseEnter: true,
	};

	const swiperObj = {
		slidesPerView: 'auto',
		spaceBetween: 20,
		watchSlidesProgress: true,
		keyboard: {
			enabled: true,
		},
		breakpoints: {
			0:{
				paused: true,
				slidesPerView: colsMobile,
				spaceBetween: 6,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			1440: {
				slidesPerView: colsDesktop,
				spaceBetween: 15,
			},
		},
		on: {
			init: function () {
				console.log('swiper initialized');
			},
		},
	}
	
	// if (swipeEffect && window.innerWidth < 768) {
	// 	swiperObj.effect = swipeEffect;
	// }

	if (pagination === 'true') {
		swiperObj.pagination = paginationObj;
	}

	if (buttons === 'true') {
		swiperObj.navigation = navigationObj;
	}

	if (autoplay === 'true') {
		swiperObj.autoplay = autoplayObj;
	}

	let swiperInstance = null;

	const initializeSwiper = () => {
			const swiperElement = document.querySelector(`.${mySwiper}`);
			if (swiperElement && (!swiperInstance || !swiperInstance.slides)) {
					swiperInstance = new Swiper(swiperElement, swiperObj);
					console.log(`.${mySwiper}`, swiperInstance);
			}
	};

	// Initialize Swiper on DOMContentLoaded
	document.addEventListener('DOMContentLoaded', () => {
			initializeSwiper();
	});

	// Use mutation observer to wait for the appearance of the Swiper element
	const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
					const swiperElement = mutation.target.querySelector(`.${mySwiper}`);
					if (swiperElement) {
							initializeSwiper();
							observer.disconnect();
					}
			});
	});

	observer.observe(document.body, {
			childList: true,
			subtree: true
	});

	// window.addEventListener('resize', () => {
	// 	if (window.innerWidth > 768) {
	// 		swiperInstance.destroy(true, true);
	// 		swiperInstance = new Swiper(mySwiperElement, {
	// 			slidesPerView: colsDesktop,
	// 			spaceBetween: 50,
	// 			keyboard: {
	// 				enabled: true,
	// 			},
	// 			pagination: pagination ? paginationObj : false,
	// 			navigation: buttons ? navigationObj : false,
	// 			autoplay: autoplay ? autoplayObj : false,
	// 		});
	// 	} else if (swiperInstance.params.effect !== swipeEffect) {
	// 		swiperInstance.params.effect = swipeEffect;
	// 		swiperInstance.update();
	// 	}
	// });
});